<placeme-layout-seo [seo]="'spiritPage.seo' | translate">
  <placeme-jumbotron [seo]="'spiritPage.seo' | translate"></placeme-jumbotron>
  <section class="main-content">
    <markdown class="page-markdown" [data]="'spiritPage.values.content' | translate"></markdown>

    <div class="valeurs">
      <div *ngFor="let items of 'spiritPage.values.items' | translate" class="valeurs__card">
        <img class="valeurs__card__logo" [src]="items.image.url" [alt]="items.title" />
        <h3 class="valeurs__card__title">{{ items.title }}</h3>
        <p class="valeurs__card__description">
          {{ items.description }}
        </p>
      </div>
    </div>
  </section>

  <section class="main-content">
    <markdown class="page-markdown" [data]="'spiritPage.profiles.content' | translate"></markdown>
    <swiper-container
      class="dark"
      slidesPerView="1"
      spaceBetween="50"
      [navigation]="showNavigation"
      pagination="true"
      pagination-clickable="true"
    >
      <swiper-slide *ngFor="let item of 'spiritPage.profiles.profiles' | translate">
        <div class="profiles">
          <div class="profiles__background">
            <img *ngIf="item" [src]="item?.seo?.image?.url" [alt]="item?.seo?.title" [title]="item?.seo?.title" />
          </div>
          <div class="profiles__card" [style.backgroundColor]="item.backgroundColor">
            <svg class="profiles__card__svg" viewBox="0 0 750 702" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill="#ffffff20"
                d="M0 568.909C19.4531 575.79 37.0252 584.229 49.5 596.5C66.7292 613.448 76.2556 627.836 84.7674 640.692C95.7474 657.275 105.039 671.309 127 685C172.246 713.207 238.089 700.391 310.472 686.301C337.641 681.013 365.731 675.545 394 672C436.148 666.714 479.008 672.778 519.848 678.556C607.579 690.968 685.99 702.062 728.001 596.5C758.196 520.629 758.049 460.523 721.5 387.5C687.322 319.215 609.272 307.804 544.041 298.268C499.605 291.771 461.117 286.145 446.5 264C433.347 244.073 422.068 220.841 410.635 197.294C388.229 151.146 365.234 103.783 326.387 77.6924C291.522 54.2763 217.684 20.8967 146.4 0.000642555L0 0V568.909Z"
              />
            </svg>
            <div class="profiles__card__img">
              <img [src]="item.icon.url" [alt]="item.name" [title]="item.name" />
            </div>
            <header class="profiles__card__container">
              <h3 class="profiles__card__container__title" [style.color]="item.color">{{ item?.seo?.title }}</h3>
              <p class="profiles__card__container__description" [style.color]="item.color">{{ item?.seo?.description }}</p>
            </header>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>
  </section>

  <section class="main-content">
    <markdown class="page-markdown" [data]="'spiritPage.career.content' | translate"></markdown>
    <placeme-status-gauge [profiles]="'spiritPage.career.profiles' | translate" [value]="20"></placeme-status-gauge>
  </section>

  <section class="main-content">
    <markdown class="page-markdown" [data]="'spiritPage.advantages.content' | translate"></markdown>
    <placeme-job-advantages [advantages]="'spiritPage.advantages.items' | translate"></placeme-job-advantages>
    <a class="join-us" placeme-fat-button [routerLink]="'spiritPage.advantages.cta.href' | translate">
      {{ 'spiritPage.advantages.cta.label' | translate }}
    </a>
  </section>
</placeme-layout-seo>
